import { useLocaleState } from "ra-core";

import { getDateFnsLocale } from "../misc/RelativeDate";

/** Returns the current UI locale and the matching date-fns locale. */
export const useDateLocale = () => {
  const [locale = "en"] = useLocaleState();
  return { locale, dateFnsLocale: getDateFnsLocale(locale) };
};
